<template>
  <div class="checklist-container mx-auto d-flex flex-column flex-grow-1 py-5">
    <div
      v-if="!isLoading"
    >
      <h5 class="alert alert-light d-flex mx-3">
        <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
        <div class="ml-2">
          {{ infoMessage }}
          Please contact us if you have any questions.
        </div>
      </h5>
      <VerificationChecklist
        :checklist-items="accountChecklistItems"
        :identity-check="accountIdentityCheck"
        class="mx-3"
      />
    </div>

    <div class="mx-3 mt-5">
      <h4>Here are some resources to help you get started</h4>
      <hr>
      <p>
        You can view the Ringba X Knowledge Base <a
          v-if="isSellerAccount"
          href="https://support.ringbax.com/hc/en-us/categories/20966966085655-Sellers"
          target="_blank"
          rel="noopener noreferrer"
        >here.
        </a>
        <a
          v-else
          href="https://support.ringbax.com/hc/en-us/categories/27838710416407-Buyer"
          target="_blank"
          rel="noopener noreferrer"
        >
          here.
        </a>
      </p>
      <p class="mt-4">
        We also have videos to help you get familiarized with the platform.
      </p>
      <div class="text-center mt-2">
        <iframe
          width="650"
          height="365.6"
          src="https://www.youtube.com/embed/videoseries?si=Nb27n87XRFVmrN81&amp;list=PLKdcVEg3F3ThW3ZmioJwuDNqtGu6dT3l-"
          title="Ringba X Platform Training"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import onboardingMixin from '@/mixins/onboarding.mixin'
import VerificationChecklist from '@/components/onboarding/VerificationChecklist.vue'

export default {
  name: 'AdminApprovalPending',

  onboardingStep: 'approval',

  title: 'Ringba X',

  components: {
    VerificationChecklist,
  },

  mixins: [onboardingMixin],

  data() {
    return {
      isLoading: false
    }
  },

  computed: {
    ...mapState('verification-checklist', [
      'accountChecklistItems',
      'accountIdentityCheck'
    ]),

    ...mapGetters('auth', [
      'accountId',
      'isSellerAccount'
    ]),

    infoMessage() {
      if (this.isLoading) {
        return ''
      }

      return this.accountChecklistItems.length
        ? 'We are in the process of doing the following verifications.'
        : 'We have received your submission. A team member is reviewing your account for final approval.'
    }
  },

  async created() {
    this.getAccountRepresentativeIdentityCheck(this.accountId)
    
    try {
      this.isLoading = true
      await this.getAccountChecklistItems(this.accountId)
    } catch {
      // console.error(e)
    } finally {
      this.isLoading = false
    }
  },

  methods: {
    ...mapActions('verification-checklist', [
      'getAccountChecklistItems',
      'getAccountRepresentativeIdentityCheck'
    ])
  },
}
</script>
<style lang="scss" scoped>
.checklist-container {
  max-width: 700px;
}
</style>